import React from 'react'

// material ui
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'

const NotificationHeader = ({ children, bgcolor }) => (
  <Container maxWidth='md'>
    <Card
      align='center'
      sx={{
        my: 2,
        color: 'text.primary',
        bgcolor: bgcolor,
        position: 'relative,'
      }}
    >
      <CardContent>{children}</CardContent>
    </Card>
  </Container>
)

export default NotificationHeader
